var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('loader'):_c('div',[(_vm.session.application_session && _vm.companyData!=null)?_c('div',[_c('company',{attrs:{"appId":_vm.session.startup_application.id,"data":_vm.companyData,"edit":_vm.edit},on:{"save-company":_vm.saveCompany,"edit-change":_vm.editchange}})],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }